import { Grid, Stack, styled, IconButton } from "@mui/material"
import { motion } from "framer-motion"

interface ProfileImgProps {
  background?: string
}

const MainWrapper = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "center",
  paddingTop: theme.spacing(0),
  rowGap: theme.spacing(0),
  boxSizing: "border-box",
  backgroundColor: "#000000",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    backgroundColor: "#ffffff",
  },
}))

const ProfileImg = styled(motion.div)<ProfileImgProps>(
  ({ theme, background }) => ({
    display: "flex",
    flexDirection: "column",
    alignContent: "start",
    alignItems: "center",
    boxSizing: "border-box",
    borderRadius: "30px",
    width: "44px",
    height: "44px",
    backgroundColor: "black",
    backgroundImage: background ? `url(${background})` : "none",
    backgroundSize: "80%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
    },
  }),
)

const HeadWrapper = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignContent: "start",
  alignItems: "center",
  padding: theme.spacing(0),
  boxSizing: "border-box",
  width: "100%",
  color: "white",
  gap: theme.spacing(0),
}))

const TitleWrapper = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignContent: "start",
  alignItems: "center",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  boxSizing: "border-box",
  width: "100%",
  color: "white",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}))

const HeroWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  height: "auto",
  overflow: "hidden",
  position: "relative",

  // desktop / default
  aspectRatio: "auto",

  // mobile square
  [theme.breakpoints.down("sm")]: {
    aspectRatio: "1 / 1",
  },
}))

// const HeroWrapper = styled("div")(() => ({
//   width: "100%",
//   height: "auto",
//   overflow: "hidden",
//   position: "relative",
// }))

const IntroWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  height: "auto",
  overflow: "hidden",
  position: "relative",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
}))

const FooterWrapper = styled(Grid)(({ theme }) => ({
  boxSizing: "border-box",
  backgroundColor: "white",
  color: "black",
  rowGap: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(6),
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(5),
  },
  [theme.breakpoints.up("lg")]: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
    paddingTop: theme.spacing(16),
    paddingBottom: theme.spacing(17),
  },
  [theme.breakpoints.up("xl")]: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
    paddingTop: theme.spacing(16),
    paddingBottom: theme.spacing(17),
  },
}))

const ProfileTitleWrapperFooter = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignContent: "start",
  alignItems: "center",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  boxSizing: "border-box",
  width: "100%",
  color: "white",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}))

const CloseDialog = styled(IconButton)(({ theme }) => ({
  height: "32px",
  width: "32px",
  position: "relative",
  color: theme.palette.text.secondary,
  [theme.breakpoints.down("sm")]: {
    backgroundColor: "white",
    position: "fixed",
    right: "16px",
    zIndex: 99,
    color: theme.palette.text.primary,
  },
}))

export {
  MainWrapper,
  ProfileImg,
  HeadWrapper,
  TitleWrapper,
  HeroWrapper,
  IntroWrapper,
  FooterWrapper,
  ProfileTitleWrapperFooter,
  CloseDialog,
}
